import type {
  AcademyNavItem,
  AcademyNavItemId,
} from '@common/components/MobileMenu/variants/AcademyMobileMenu/academy-mobile-menu.interface'
import { buildDocsDocumentationHref } from '@common/utils/buildDocsDocumentationHref'
import { getDocsExternalUrl } from '@common/utils/getDocsExternalUrl'

import { ACADEMY_ROUTES } from './academy.const'

const LEADING_H1 = /^(?:\uFEFF)?(?:[ \t]*\r?\n)*[ \t]*#[ \t]+[^\r\n]+(?:\r?\n|$)/

export function stripLeadingMarkdownH1(content: string): string {
  return content.replace(LEADING_H1, '').replace(/^(?:[ \t]*\r?\n)+/, '')
}

export function scrollWindowToTopSmooth() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

export function scrollElementToTopSmooth(element: HTMLElement | null) {
  if (!element) {
    return
  }
  element.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

export function getAcademyDocumentationNavUrl(slug?: string): string {
  const docsUrl = getDocsExternalUrl()

  if (docsUrl) {
    return buildDocsDocumentationHref(docsUrl, slug)
  }

  return slug ? `${ACADEMY_ROUTES.documentation}/${slug}` : ACADEMY_ROUTES.documentation
}

export function getAcademySidebarNavUrl(item: AcademyNavItem): string {
  if (item.id === 'documentation') {
    return getAcademyDocumentationNavUrl()
  }

  return item.path
}

export function isAcademySidebarNavItemActive(itemId: AcademyNavItemId, pathname: string): boolean {
  const path = pathname.split('?')[0] || ''

  if (itemId === 'documentation') {
    return !getDocsExternalUrl() && path.startsWith(ACADEMY_ROUTES.documentation)
  }

  if (itemId === 'quickStart') {
    return path.startsWith(ACADEMY_ROUTES.quickStart)
  }

  if (itemId === 'videos') {
    return path.startsWith(ACADEMY_ROUTES.videos)
  }

  if (itemId === 'home') {
    return path === '' || path === '/'
  }

  return path.startsWith(ACADEMY_ROUTES[itemId] ?? '')
}
